var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sun not-full",attrs:{"id":"DocumentLimitTransactionInformation"}},[_vm._v(" 본인은 ㈜펀다와 아래의 조건에 따라 여신거래를 함에 있어 아래 약관이 적용됨을 승인하고, 다음 각 조항을 확약합니다. ")])}
var staticRenderFns = []

export { render, staticRenderFns }